import {
  Component,
  Input,
  OnInit,
  EventEmitter,
  Output,
  ChangeDetectorRef,
} from "@angular/core";

@Component({
  selector: "evrideo-layer-input",
  templateUrl: "./layer-input.component.html",
  styleUrls: ["./layer-input.component.scss"],
})
export class LayerInputComponent implements OnInit {
  @Input()
  zIndex = 0;

  @Input()
  minNumber = 0;
  @Input()
  maxNumber = 100;

  @Input()
  label = "LAYER";

  @Input()
  labelWidth = "42px";

  @Input()
  shortLabel = "Z";

  @Input()
  pattern = "[0-9]*";

  @Output()
  zIndexChange = new EventEmitter<number>();

  @Input()
  showTooltip = true;

  private _lastValue: number;

  constructor() {}

  ngOnInit(): void {
    this._lastValue = this.zIndex;
  }

  zIndexChangeEventHandler(event: any) {
    const zIndex = parseInt(event.target.value);
    if (zIndex >= this.minNumber && zIndex <= this.maxNumber) {
      //console.log('LayerInputComponent->zIndexChangeEventHandler', zIndex);
      this.zIndexChange.emit(Math.abs(zIndex));
      this._lastValue = zIndex;
      this.zIndex = zIndex;
    } else {
      this.zIndex = this._lastValue;
      event.target.value = this._lastValue;
    }
  }
}
